import { register } from '@forter/core';
import { FcCheckboxScroll } from './FcCheckboxScroll.js';

register(FcCheckboxScroll);
